import { Controller } from "@hotwired/stimulus"

// Backs quote_bundles/edit_bulk.html.erb's bulk-assign modal: the "select all" checkbox that
// toggles every per-quote checkbox, and populating the hidden provider_id field from the
// autocomplete controller's "autocomplete.change" event. Replaces what used to be an inline
// <script> block (AGENTS.md: no inline scripts).
export default class extends Controller {
  static targets = ["checkbox", "providerId"]

  toggleAll(event) {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = event.target.checked
    })
  }

  setProviderId(event) {
    if (event.detail && event.detail.value) {
      this.providerIdTarget.value = event.detail.value
    }
  }
}
